import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className="content">

        <Heading
          subTitle={"Explore Our Services"}
          title={"Bring Your Ideas to Life with Professional Print Solutions"}
          linear
          sideHeading
        />
        
        <Button link={"Services"} title={"View Services"} />

      </div>
    </section>

  );

};

export default Banner;